import { Role } from "./user"

const _CONTACT_TYPES = ["User", "AlternateContact"] as const

export type ContactType = (typeof _CONTACT_TYPES)[number]

export interface Participant {
	displayName?: string
	fullName: string
	userType?: Role
	id?: string
	readOnly?: boolean
	contactType?: ContactType
	isActive?: boolean
	hasEmailAddress?: boolean
	supportsTextMessages: boolean
}

export enum MessageStatus {
	ERROR = "error",
	CANCELED = "canceled",
	QUEUED = "queued",
	SENT = "sent",
	DELIVERED = "delivered",
	FAILED = "failed",
	UNDELIVERED = "undelivered",
	RECEIVED = "received",
}

export enum MessageType {
	voicemail = "voicemail",
	voice = "voice",
	message = "message",
	email = "email",
	inApp = "in-app",
}

export const MessageTypeLabel = {
	[MessageType.voicemail]: "Voicemail",
	[MessageType.voice]: "Voice call",
	[MessageType.message]: "Text message",
	[MessageType.email]: "Email",
	[MessageType.inApp]: "Chat message",
} as Record<MessageType, string>

export enum CallStatus {
	ACCEPTED = "accepted",
	INITIATED = "initiated",
	IN_PROGRESS = "in-progress",
	RINGING = "ringing",
	COMPLETED = "completed",
	CANCELED = "canceled",
	NO_ANSWER = "no-answer",
	BUSY = "busy",
	FAILED = "failed",
}

export interface ChatMessage {
	id: string
	sender: string
	senderInfo: Partial<Participant>
	receiverInfo?: Partial<Participant> | null
	receiver?: string | null
	type: MessageType
	timestamp: string
	isRead: boolean
	text?: string
	mediaUrl?: string
	mediaOriginalName?: string
	duration?: number
	status?: MessageStatus | CallStatus
	fromType: ContactType
	toType: ContactType
	subject?: string
	inReplyTo?: string
	threadId?: string
}

export type MessagePayload = Pick<
	ChatMessage,
	"type" | "text" | "subject" | "inReplyTo" | "threadId"
> & {
	id?: string
	file?: File | null
}
